import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import validator from "validator";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { ADMIN_LOCAL_STORE, CURRENT_YEAR, SALT } from "../../configs/AppConfig";
import { adminPost2FAVerifyQrCode, login } from "../../services/AdminService";
import { encryptData } from "../../utils/crypto";
import Logo from '../../assets/Images/Docusafe_logo.webp';
import '../guest-portal/Auth/AuthPages.css';


function AdminPortalLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [isVerify, setIsVerify] = useState(false);
    const [userData, setUserData] = useState({});
    const [code, setCode] = useState('');

    let errorsObj = { email: '', password: '' };
    const [errors, setErrors] = useState(errorsObj);

    function onLogin(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (email === '') {
            errorObj.email = 'Email is required';
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = 'Please enter valid email address';
            error = true;
        }
        if (password === '') {
            errorObj.password = 'Password is required';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        setLoading(true);
        let obj = {
            email: email,
            password: password
        };
        login(obj)
            .then(response => {
                if (response.data.data.qr_code) {
                    setIsVerify(true);
                    setLoading(false);
                    setUserData(response.data.data);
                } else {
                    let encryptedData = encryptData(response.data.data, SALT);
                    localStorage.setItem(ADMIN_LOCAL_STORE, encryptedData);
                    navigate('/back-admin');
                    setLoading(false);
                }
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    }

    const onVerify = (e) => {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };

        if (!code) {
            errorObj.code = 'Code is required';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        setLoading(true);
        let data = { ...userData };

        let obj = {
            id: data.id,
            code: code
        };

        adminPost2FAVerifyQrCode(obj)
            .then(response => {
                let encryptedData = encryptData(userData, SALT);
                localStorage.setItem(ADMIN_LOCAL_STORE, encryptedData);
                setLoading(false);
                navigate('/back-admin');
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    };

    return (
        <div className="wrapper guest-portal">

            {loading && <div className="page-loading">
                <img src="/images/loader.gif" alt="loader" />
            </div>}
            <div className=""
                style={{ minHeight: 'calc(100vh - 70px)' }}>
                <div className="login-container">
                    <div className="d-flex align-items-center justify-content-center mb-3">
                        <img src={Logo} alt="" className="docusafe_logo" />
                    </div>
                    <div className="login-card">
                        <h2 className="login-title"> {isVerify ? `Two Factor Authentication Code` : `Login`}</h2>
                        <div className="login-card-body">
                            {isVerify && (
                                <form onSubmit={onVerify}>
                                    <div className="form-group">
                                        <label className="form-label">Google Authenticator App Code</label>
                                        <input type="number" className="form-control" value={code}
                                            onChange={(e) => setCode(e.target.value)}
                                            placeholder="Enter 6-digit code found in your App" />
                                        {errors.code && <div className="text-danger mt-1">{errors.code}</div>}
                                    </div>
                                    <button type="submit" className="login-btn-page w-100 mb-3 border-0 btn_bg">Verify</button>
                                </form>
                            )}

                            {!isVerify && (
                                <form onSubmit={onLogin}>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="text" className="form-control" id="email" value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            aria-describedby="emailHelp" placeholder="user@example.com" />
                                        {errors.email && <div className="text-danger mt-1">{errors.email}</div>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <input type="password" className="form-control" value={password}
                                            onChange={(e) => setPassword(e.target.value)} id="password" />
                                        {errors.password && <div className="text-danger mt-1">{errors.password}</div>}
                                    </div>
                                    <button type="submit" className="login-btn w-100 mb-3 border-0 btn_bg">Submit</button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <footer className="bg-dark text-center text-lg-start text-white">
                <div className="py-2" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
                    <div className="container my-2">
                        <div className="row">
                            <div className="col-md-12">
                                <p className="text-center text-white">
                                    © {CURRENT_YEAR} <NavLink to={"/"} className="text-white">DocuSafe.ai Pty Ltd.</NavLink> All rights
                                    reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default AdminPortalLogin;